import React from "react";
import moment from "moment";
import { formatCurrency } from "../../../../utils/SamuiUtils";
import { formatThaiDateUi } from "../../../../utils/DateUtils";

export default function DetailModal({
  open,
  onClose,
  data,
  fields,
  info,
  onPrev,
  onNext,
  totalSummary,
}) {
  if (!open) return null;
  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal d-block" tabIndex={-1}>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                รายการสั่งซื้อของ {info.code} - {info.name}
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              <div className="table-responsive">
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      {fields.map((f) => (
                        <th
                          key={f.key}
                          style={{ width: f.w }}
                          className={`text-${f.alignHeader} text-nowrap`}
                        >
                          {f.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((d, i) => (
                        <tr key={i}>
                          {fields.map((f) => (
                            <td
                              key={f.key}
                              className={`text-${f.align}${f.numeric ? " text-end" : ""
                                }`}
                            >
                              {f.key === "Doc_Date"
                                ? formatThaiDateUi(moment(d[f.key]))
                                : f.key === "NetTotal"
                                  ? formatCurrency(d.Item_Price_Unit * d.Item_Qty)
                                  : f.numeric
                                    ? formatCurrency(d[f.key])
                                    : d[f.key]}
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={fields.length}>
                          <center>ไม่พบรายการ</center>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={fields.length - 3} className="text-end">
                        รวมทั้งหมด {data.length} รายการ
                      </td>
                      <td className="text-end">
                        {formatCurrency(
                          data.reduce(
                            (s, d) => s + d.Item_Price_Unit * d.Item_Qty,
                            0
                          )
                        )}
                      </td>
                      <td className="text-end">
                        {formatCurrency(
                          data.reduce((s, d) => s + (d.Item_Discount || 0), 0)
                        )}
                      </td>
                      <td className="text-end">
                        {formatCurrency(
                          data.reduce((s, d) => s + (d.Item_Total || 0), 0)
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div className="modal-footer position-relative justify-content-center">
              <span className="position-absolute start-0 ps-3">
                {info.index + 1} / {totalSummary}
              </span>

              <button
                className="btn btn-outline-orange"
                onClick={onPrev}
                disabled={info.index === 0}
              >
                ก่อนหน้า
              </button>
              <button
                className="btn btn-outline-orange ms-2"
                onClick={onNext}
                disabled={info.index === totalSummary - 1}
              >
                ถัดไป
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
